import  { useState ,useEffect,useRef} from 'react';
import { Link } from 'react-router-dom';
import CoupanServices from '../services/CoupanServices';
import useAsync from '../hooks/useAsync';
import TogelButtonForStatus from './TogelButton/TogalButtonForStatus';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import CoupanUpdate from './Update Model/UpdateCoupan';
import Coupanview from './View Model/ViewCoupan';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
Modal.setAppElement('#root');
function RevertCoupanHistory() {
  
  const { data, error, isLoading, run } = useAsync(CoupanServices.RevertgetCoupanHistory);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [pendingPage, setPendingPage] = useState(null)
  const [currentPage, setCurrentPage] = useState(1);
   const [limit, setLimit] = useState(20);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [selectedView, setSelectedView] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
const [fromDate, setFromDate] = useState('');
const [toDate, setToDate] = useState('');
  const lastPagination = useRef({ totalPages: 1, total: 0 });
    useEffect(() => {
    if (data?.pagination) {
      lastPagination.current = data.pagination;
    }
  }, [data]);


   const buildQuery = (page) => {
    let q = `?page=${page}&limit=${limit}`;
    if (searchQuery.trim()) q += `&search=${encodeURIComponent(searchQuery.trim())}`;
    if (fromDate) q += `&fromDate=${fromDate}`;
    if (toDate)   q += `&toDate=${toDate}`;
    return q;
  };
  const handleEditDetails = (coupan) => {
    setSelectedEdit(coupan);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleViewDetails = (coupan) => {
    setSelectedView(coupan);
    setIsViewModalOpen(true);
    toggleActionMenu(null);
  };
useEffect(() => {
  run(currentPage, limit);
}, [currentPage, limit]);


  useEffect(() => {
  const pageToFetch = pendingPage ?? currentPage;
  run(buildQuery(pageToFetch));
}, [currentPage, pendingPage, limit,searchQuery, fromDate, toDate]);

useEffect(() => {
  if (!isLoading && pendingPage !== null) {
    setCurrentPage(pendingPage);
    setPendingPage(null);
  }
}, [isLoading, pendingPage]);

const handlePageClick = (data) => {
  setPendingPage(data.selected + 1);
};
const applyFilter = () => setPendingPage(1); 
  const handleDelete = (coupan) => {
    setSelectedEdit(coupan);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const closeViewModal = () => {
    setIsViewModalOpen(false);
    setSelectedView(null);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  function formatDateTime(isoString) {
    if (!isoString) return '-';
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  
const totalPages = data?.pagination?.totalPages 
                 ?? lastPagination.current.totalPages 
                 ?? 1;
const rows = data?.data || [];
// const rows = data?.data || [];
  
  // const usersPerPage = 20;
  // const indexOfLastUser = currentPage * usersPerPage;
  // const indexOfFirstUser = indexOfLastUser - usersPerPage;


  // const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const generateExcel = () => {
    const excelData = data?.data?.map(coupan => ({
       "Date & Time": formatDateTime(coupan.coupan.createdAt),
      "Coupon Name": coupan?.coupon?.name || "-",
      "User Name": `${coupan?.user?.name || ""} `,
      "User Mobile": `${coupan?.user?.mobileNo || ""} `,
      // "Vendor Name": coupan?.vendor?.name || "-",
      "Service": coupan?.service?.title || "-",
      // "Date Time": coupan?.dateTime || "-",
    }));
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'CoupanData');
    XLSX.writeFile(wb, 'coupan_data.xlsx');
  };
  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
          <div className="my-auto">
            <h5 className="page-title fs-21 mb-1">
             Applied Coupon History List <span className="badge bg-orange">  {data?.pagination?.total ?? lastPagination.current.total ?? 0} </span>
            </h5>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                 Applied Coupon History List
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
            {/* <Link className="round-add-btn" to="/add-couponNew">
              <img src="img/plus.svg" alt="Add Coupan" />
            </Link> */}
            <button className="excel-btn" onClick={generateExcel}>
              <img src="img/excel.svg" alt="Download Excel" />
              Download
            </button>
          </div>
        </div>

        <div className="container-box px-0 pt-2">
          {/* <div className="Tablesearch_design">
            <div className="row">
              <div className='col-md-6'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search by coupon name"
                    className='form-control'
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <button className="search-btn">Search</button>
                </div>
              </div>
            </div>
          </div> */}
<div className="Tablesearch_design">
  <div className="row g-2 align-items-end">
    <div className="col-md-4">
      <label className="form-label mb-1">Search</label>
      <input
        type="search"
        name="search"
        placeholder="Search by coupon /user "
        className="form-control"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
    </div>

    <div className="col-md-3">
      <label className="form-label mb-1">From Date</label>
      <input
        type="date"
        className="form-control"
        value={fromDate}
        max={toDate || undefined}
        onChange={(e) => setFromDate(e.target.value)}
      />
    </div>

    <div className="col-md-3">
      <label className="form-label mb-1">To Date</label>
      <input
        type="date"
        className="form-control"
        value={toDate}
        min={fromDate || undefined}
        onChange={(e) => setToDate(e.target.value)}
      />
    </div>

    <div className="col-md-2 d-flex gap-2">
     {/* <button
  className="search-btn"
  onClick={() => {
    setPendingPage(1); 
    run(buildQuery(1)); 
  }}
>
  Search
</button> */}
  <button
  className="btn btn-secondary"
  onClick={() => {
    setSearchQuery('');
    setFromDate('');
    setToDate('');
    setPendingPage(1);
    run(`?page=1&limit=20`); // Reset karke direct API call karega
  }}
>
  Reset
</button>
    </div>
  </div>
</div>
          <div className="container-box-inner table-responsive px-3">
            <table id="example" className="table table-striped" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Date&Time</th>
                  <th>Coupon Name</th>
                  <th>User Name</th>
                  <th>Mobile No.</th>
                  {/* <th>Vendor Name</th> */}
                  <th>Service Name</th>
                  {/* <th>Date Time</th> */}
                  {/* <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {rows?.map((coupan, i) => (
                  <tr key={coupan._id || i}>
                     <td>{(currentPage - 1) * limit + i + 1}</td>
                    <td>{formatDateTime(coupan.createdAt)}</td>
                    <td>{coupan?.coupon?.name || "-"}</td>
                    <td>{coupan?.user?.name || ""}</td>
                    <td>{coupan?.user?.mobileNo || ""}</td>
                    {/* <td>{coupan?.vendor?.name || "-"}</td> */}
                    <td>{coupan?.service?.title || "-"}</td>
                    {/* <td>{coupan?.dateTime || "-"}</td> */}
                    {/* <td className="status-toggle">
                      <TogelButtonForStatus data={coupan} page="Coupan" onSuccess={() => run()} />
                    </td>
                    <td>
                      <div className="action_toggle_outer">
                        <button className="action_toggle" onClick={() => toggleActionMenu(i)}>
                          <i className="fa fa-ellipsis-v" />
                        </button>
                        {activeIndex === i && (
                          <div className="action_toggle_content product-edit show d-block">
                            <ul className="list-unstyled">
                              <li>
                                <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                  <i className="fa fa-close" />
                                </button>
                              </li>
                              <li>
                                <button className="view" style={{ backgroundColor: '#263238' }} onClick={() => handleViewDetails(coupan)}>View</button>
                              </li>
                              <li>
                                <button className="edit" onClick={() => handleEditDetails(coupan)}>Edit</button>
                              </li>
                              <li>
                                <button className="reject" onClick={() => handleDelete(coupan)}>Delete</button>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
           <div className="pagination">
                    <ReactPaginate
                   pageCount={totalPages}   
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={1}
                      onPageChange={handlePageClick}
                      containerClassName={'pagination'}
                      activeClassName={'active'}
                      previousLabel={'Previous'}
                      nextLabel={'Next'}
                      breakLabel={'...'}
                      breakClassName={'break-me'}
                      forcePage={(pendingPage ?? currentPage) - 1}
                      // disableInitialCallback={true}
                      pageLinkClassName={'page-link'}
                      previousLinkClassName={'page-link'}
                      nextLinkClassName={'page-link'}
                      pageClassName={'page-item'}
                      previousClassName={'page-item'}
                      nextClassName={'page-item'}
                      disabledClassName={'disabled'}
                      disabled={isLoading}
                    />
                  </div>
        </div>

        {/* Edit Modal */}
        <Modal
          isOpen={isEditModalOpen}
          onRequestClose={closeEditModal}
          contentLabel="Edit Coupon"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <CoupanUpdate data={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
        </Modal>

        {/* Delete Modal */}
        <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          contentLabel="Delete Confirmation"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="Coupan" closeModal={closeDeleteModal} onSuccess={run} />
        </Modal>

        {/* View Modal */}
        <Modal
          isOpen={isViewModalOpen}
          onRequestClose={closeViewModal}
          contentLabel="View Coupon Details"
          className="modal-content modal-lg"
          overlayClassName="modal-overlay"
        >
          <Coupanview coupan={selectedView} closeModal={closeViewModal} />
        </Modal>
      </div>
    </>
  );
}

export default RevertCoupanHistory;